import { Node, Element as SlateElement } from 'slate'

import { BLOCK_FORMATS, LIST_TYPES } from '../../interface/custom-types'

export const isList = (node: Node): boolean =>
  SlateElement.isElement(node) && LIST_TYPES.includes(node.type as BLOCK_FORMATS)

export const isListItem = (node: Node): boolean =>
  SlateElement.isElement(node) && node.type === BLOCK_FORMATS.listItem
